<mat-card appearance="outlined">
    <div class="container text-center">
        <p style="font-weight: bold">Importación de contactos mediante Excel</p>
        <hr>
        <ng-container *ngIf="!dataReady">
            <hr>
            <p>
                Mediante el siguiente proceso podrá importar sus contactos a Handly mediante una plantilla en Excel.
            </p>
            <p>
              Dicha plantilla deberá tener el formato indicado en el siguiente ejemplo:
            </p>
            <div class="d-flex justify-content-center flex-column flex-md-row">
                <button mat-stroked-button (click)="downloadTemplate()" class="lblWhiteSpaceNormal me-0 me-md-2 mb-2 mb-md-0">Descargar
                    plantilla</button>
                <button mat-stroked-button (click)="downloadDemoTemplate()" class="lblWhiteSpaceNormal">Descargar
                    ejemplo con datos</button>
            </div>
            <p></p>
            <p>Una vez haya cumplimentado la plantilla correctamente, súbala en el siguiente paso y verá una vista
              previa de los datos.</p>
            <p></p>
            <input matinput type="file" (change)="fileChange($event)" placeholder="Upload file" accept=".xlsx" class="input-upload-contact">
            <div class="d-flex justify-content-center mt-3">
                <button mat-stroked-button (click)="closeDialog()">
                    <mat-icon>close</mat-icon>
                    Cerrar
                </button>
            </div>
        </ng-container>

        <ng-container *ngIf="working">
            <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
        </ng-container>
        <ng-container *ngIf="dataReady">
            <button mat-stroked-button (click)="addContacts()" class="me-2">Añadir contactos a Handly</button>
            <button mat-stroked-button (click)="closeDialog()">Cerrar</button>
        </ng-container>
    </div>
</mat-card>
<ng-container *ngIf="dataReady">
    <ng-container *ngIf="!working">
        <app-table [columns]="headerTable" [dataSource]="dataSource"></app-table>
    </ng-container>
</ng-container>
